/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Content } from '../../models/content';
import { UpdateContentDto } from '../../models/update-content-dto';

export interface ContentControllerUpdate$Params {
  contentId: string;
      body: UpdateContentDto
}

export function contentControllerUpdate(http: HttpClient, rootUrl: string, params: ContentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Content>> {
  const rb = new RequestBuilder(rootUrl, contentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('contentId', params.contentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Content>;
    })
  );
}

contentControllerUpdate.PATH = '/content/{contentId}';
